<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="!environment.brandConfig.hero && vm.theme"
    [themeFlush]="true"
    class="custom-background"
  >
    <dgx-components-grid-container class="article-search__wrapper">
      <ng-container *ngIf="environment.brandConfig.hero; else remoteHero">
        <dgx-components-grid-row>
          <dgx-components-grid-column
            [xs]="12"
            [sm]="6"
            class="local-form-column"
          >
            <ng-container *ngIf="!isScottishPower(); else scottishPowerContent">
              <h6 class="article-search__intro">
                {{ 'Maintenance & Support Portal' }}
              </h6>
              <h1 class="article-search__title">
                {{ 'Search our how-to guides' }}
              </h1>
            </ng-container>

            <ng-template #scottishPowerContent>
              <h1 class="article-search__title_scottish">
                {{ 'Welcome' }}
              </h1>
              <div class="pb-4"></div>
              <p class="subtitle_scottish">
                to Domestic & General’s Maintenance & Support portal for
                {{ isScottishPowerHeating() ? 'Boiler' : 'Appliance' }} Care
                customers.
              </p>
              <div class="pb-4"></div>
              <ng-container
                *ngIf="isScottishPowerHeating(); else applianceContent"
              >
                <p>
                  Here you can find a range of information to help you look
                  after your boiler, and you can access it whenever you need to.
                </p>
                <br />
                <p>
                  This includes advice on keeping your heating system running
                  smoothly, guides on gas safety in your home, and
                  troubleshooting information. You'll also get a number of other
                  hints and tips on your boiler throughout the duration of your
                  plan.*
                </p>
              </ng-container>
              <ng-template #applianceContent>
                <p>
                  Here you can find a range of services aimed at keeping your
                  appliance running smoothly, and you can access them whenever
                  you need to. These services include set-up support and a guide
                  on how to carry out an annual health check of your appliance.
                </p>
                <br />
                <p>
                  You'll also get ongoing advice and tips on your appliance type
                  throughout the duration of your plan.*
                </p>
              </ng-template>
              <div class="pb-4"></div>
              <p class="dandg-disclaimer">
                {{ scottishPowerDisclaimer }}
              </p>
              <div class="pb-7"></div>
              <h4 class="article-search__guides_scottish">
                {{ 'Search our how-to guides' }}
              </h4>
            </ng-template>
            <form
              [ngClass]="{
                scottish_power_form: isScottishPower(),
              }"
              *ngIf="cs.form as form"
              (submitted)="onFormSubmit($event)"
              [formGroup]="cs.form"
              dgxFormSubmit
            >
              <dgx-form-row>
                <dgx-form-field formControlName="search">
                  <article-search-form-field
                    [placeholder]="'Start typing a topic...'"
                  />
                </dgx-form-field>
              </dgx-form-row>
            </form>
          </dgx-components-grid-column>
          <dgx-components-grid-column
            [xs]="12"
            [sm]="6"
            class="local-hero-column"
          >
            <dgx-components-picture
              [alt]="environment.brandConfig.hero.alt"
              [aspectRatio]="environment.brandConfig.hero.aspectRatio"
              [fit]="'cover'"
              [lazy]="false"
              [position]="'center'"
              [src]="environment.brandConfig.hero.src"
              class="hero"
            />
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </ng-container>
      <ng-template #remoteHero>
        <dgx-components-grid-row
          *ngIf="vm.picture | cmsPicture as picture"
          class="article-search_hero-picture"
        >
          <dgx-components-grid-column [xs]="0" [sm]="4" />
          <dgx-components-grid-column [xs]="12" [sm]="4" class="hero-column">
            <dgx-components-picture
              [alt]="picture.alt"
              [aspectRatio]="'240:222'"
              [fit]="'contain'"
              [lazy]="false"
              [position]="picture.position"
              [sourceSet]="picture.sourceSet"
              [src]="picture.src"
              class="hero"
            />
          </dgx-components-grid-column>
        </dgx-components-grid-row>
        <dgx-components-grid-row>
          <dgx-components-grid-column [lg]="2" [xs]="12" />
          <dgx-components-grid-column [lg]="8" [xs]="12">
            <h6 *ngIf="vm.articleSearchIntro" class="article-search__intro">
              {{
                environment.hasMyAccountIntegration
                  ? vm.articleSearchIntro
                  : 'Maintenance & Support Portal'
              }}
            </h6>
            <h1 *ngIf="vm.articleSearchTitle" class="article-search__title">
              {{
                environment.hasMyAccountIntegration
                  ? vm.articleSearchTitle
                  : 'Search our how-to guides'
              }}
            </h1>
          </dgx-components-grid-column>
        </dgx-components-grid-row>
        <dgx-components-grid-row *ngIf="vm.articleSearchBody">
          <dgx-components-grid-column [xs]="12">
            <p class="typog-body-large">
              {{ vm.articleSearchBody }}
            </p>
          </dgx-components-grid-column>
        </dgx-components-grid-row>
        <dgx-components-grid-row *ngIf="showForm">
          <dgx-components-grid-column [lg]="3" [xl]="3" [xs]="12" />
          <dgx-components-grid-column [lg]="6" [xl]="6" [xs]="12">
            <ng-container>
              <form
                *ngIf="cs.form as form"
                (submitted)="onFormSubmit($event)"
                [formGroup]="cs.form"
                dgxFormSubmit
              >
                <dgx-form-row>
                  <dgx-form-field formControlName="search">
                    <article-search-form-field
                      [placeholder]="'Start typing a topic...'"
                    />
                  </dgx-form-field>
                </dgx-form-row>
              </form>
            </ng-container>
            <!-- <dgx-components-quick-links
            [quickLinks]="vm.quickLinks"
            label="Quick links"
          /> -->
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </ng-template>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
